import { combineReducers } from "redux";
import Alert from "./Alert";
import AuthRedux from "./Auth";
import Orders from "./Orders";
import Provine from "./Provine";
import Statistics from "./Statistics";
import Products from "./Products";
import ProvineNew from "./ProvineNew";
import Settings from "./Settings";
import Chat from "./Chat";
import ChatTags from "./ChatTags";
import QuickReplies from "./QuickReplies";
export default combineReducers({
  Alert,
  AuthRedux,
  Orders,
  Provine,
  ProvineNew,
  Statistics,
  Products,
  Settings,
  Chat,
  ChatTags,
  QuickReplies,
});
